// import intlTelInput from "intl-tel-input"; //Creating issues
import "intl-tel-input/styles";

const inputs = document.querySelectorAll('input[type="tel"]');
export let iti;
window.internationalPhoneFields = {};

const initialCountryLookup = async () => {
    const res = await fetch("https://ipapi.co/json");
    const data = await res.json();
    return data.country_code;
};
if (inputs.length > 0) {
    setTimeout(() => {

        inputs.forEach((input) => {
            input.addEventListener('keyup', (e) => {
                input.value = input.value
                    .replace(/\D/g, '')
                    .replace(/(\d{3})(\d{3})(\d{0,4}).*/, (_, a, b, c) =>
                        [a, b, c].filter(Boolean).join(' ')
                    );
            })
            /* const instance = intlTelInput(input, {
                initialCountryLookup,
                countrySelectorMode: "OFF",
                initialCountry: "us",
                separateDialCode: false,
                loadUtils: () => import("../plugin/intlInput/utils.js"),
                // loadUtils: () => import("intl-tel-input/utils"),
            });
            window.internationalPhoneFields[input.id] = instance; */

        })
    }, 400);
}